import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { getLawInterfaceFromStorage } from 'CorePackage/MainModule/common/getLawInterfaceFromStorage';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';

import { IKnm } from '../interfaces/IKnm';

export async function fetchKnmDownloadCurrent(knmId: IKnm['id']): Promise<IExport> {
  return apiPost<IExport>({ url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/export/${knmId}/version` });
}

interface IFetchKnmExport {
  id: number;
  format: ExportFormatsEnum;
}

export async function fetchKnmExport({ id, format }: IFetchKnmExport): Promise<IExport> {
  const lawInterface = getLawInterfaceFromStorage();
  const params = new URLSearchParams();

  params.set('format', format);
  params.set('isFederalLaw248', String(lawInterface === LawInterfacesEnum.FZ_248));

  return apiPost<IExport>({ url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/export/${id}?${params}` });
}

export async function fetchKnmXmlDownloadById(id: number): Promise<Blob> {
  return apiGet<Blob>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/${id}/download/xml`);
}

export async function fetchDocDecisionByIdDoc(id: string): Promise<Blob> {
  return apiGet<Blob>(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/decision/docx`);
}

export async function fetchDocDecisionByIdOdt(id: string): Promise<Blob> {
  return apiGet<Blob>(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/decision/odt`);
}

export async function generateExtract(id: string, format: string): Promise<Blob> {
  const params = new URLSearchParams();

  params.set('format', format);

  return apiGet<Blob>(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/extract?${params}`);
}

export async function fetchDocWarningById(id: string): Promise<Blob> {
  return apiGet<Blob>(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/warning`);
}

export async function generateExtractPm(id: string): Promise<Blob> {
  return apiGet<Blob>(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/extract-pm`);
}
